import styled from 'styled-components';
import {
  compose,
  space,
  SpaceProps,
  display,
  DisplayProps,
  borders,
  BordersProps
} from 'styled-system';

type StyledFieldsetProps = SpaceProps & DisplayProps & BordersProps;
export interface IStyledFieldsetProps
  extends React.FieldsetHTMLAttributes<HTMLFieldSetElement>,
    StyledFieldsetProps {
  /**
   * @default false
   * Renders Form.Section in disabled state
   */
  disabled?: boolean;
}

export const StyledFieldset = styled.fieldset<IStyledFieldsetProps>`
  ${compose(space, display, borders)}
  ${({ disabled }) =>
    disabled
      ? `
    & [data-formitem="true"] input, & [data-formitem="true"] label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  `
      : ''}
`;
